import React from 'react';
import PropTypes from 'prop-types';
import style from './FullColumnTextBlock.module.scss';

const FullColumnTextBlock = props => {
    const { title, description, backgroundColour, fullWidthBackground } = props;

    return (
        <section
            data-bg={backgroundColour}
            className={[
                style.el,
                'full-col-text',
                fullWidthBackground ? '' : style.containerWidth,
                backgroundColour === 'white' ? style.white : backgroundColour === 'grey' ? style.grey : backgroundColour === 'blue' ? style.blue : '',
            ].join(' ')}
        >
            <div className={[style.container, 'container'].join(' ')}>
                <div className={style.content}>
                    {title !== '' && <h2 className={style.title}>{title}</h2>}
                    {description !== '' && (
                        <div className={style.description} dangerouslySetInnerHTML={{ __html: description }}></div>
                    )}
                </div>
            </div>
        </section>
    );
};

FullColumnTextBlock.propTypes = {
    title: PropTypes.any,
    description: PropTypes.string,
    backgroundColour: PropTypes.string,
    fullWidthBackground: PropTypes.bool
};
export default FullColumnTextBlock;

FullColumnTextBlock.defaultProps = {};
